<template>
	<div class="border-1">
		<div class="border-2">
			<router-link :to="link" class="contacto" :href="link" :class="{ sub: theme === 'sub' }">
				<i class="fas fa-chevron-left" style="color: var(--green-color)"></i>
				{{ text }}
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	name: 'btn',
	props: ['text', 'theme', 'link']
};
</script>

<style scoped>
.border-1 {
	background: linear-gradient(to left, var(--green-color), var(--yellow-color));
	border-radius: 20px;
	padding: 1px;
}
.border-2 {
	padding: 7px 20px;
	background: white;
	border-radius: 20px;
}
.contacto {
	display: flex;
	align-items: center;
	width: max-content;
	text-decoration: none;
	cursor: pointer;
	color: var(--green-color);
	font-size: 13px;
}
.contacto * {
	display: inline;
}

.contacto svg {
	width: 10px !important;
	margin-right: 6px;
	filter: invert(42%) sepia(37%) saturate(639%) hue-rotate(85deg)
		brightness(96%) contrast(93%);
}
.border-1:hover {
	-webkit-box-shadow: 1px 1px 3px #999;
	box-shadow: 1px 1px 3px #999;
}
</style>
